import styled from 'styled-components';

export const Container = styled.div`
	padding: 40px;
	font-family: 'Montserrat', 'Arial', 'Roboto', sans-serif;
`;

export const Wrapper = styled.div`
	position: relative;
	background-color: #fff;
	min-height: 75vh;
	height: 100%;
	border-radius: 6px;
	padding: 20px;
	width: 100%;

	.logo {
		position: absolute;
		top: -30px;
		margin: auto;
		left: 0;
		right: 0;
		text-align: center;
	}
`;

export const Header = styled.div`
	display: grid;
	place-items: center;
	padding: 0 40px;
`;

export const Main = styled.div`
	width: 100%;
	padding: 0 40px;
`;

export const Title = styled.p`
	font-weight: 600;
	font-size: 20px;
	display: flex;
	align-items: center;
	text-align: center;
	color: #5082c2;
	margin: 24px 0;
`;

export const Description = styled.p`
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 30px;
	color: #64778f;
	width: 70%;
`;

export const Footer = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-top: 40px;
	& > div {
		display: flex;
		& > button + button {
			margin-left: 14px;
		}
	}
`;

export const LoadingContainer = styled.div`
	display: grid;
	place-items: center;
	height: 30vh;
`;

export const FinishModal = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	place-items: center;
	gap: 16px;
	color: #64778f;
	font-family: 'Montserrat', 'Arial', 'Roboto', sans-serif;

	.boldtext {
		font-weight: 600;
	}

	p {
		text-align: center;
	}
`;
